import { ROLE, USER, USER_MANAGEMENT_AUDIT_LOG } from '@shared/permissions';

const APP_PERMISSIONS = {
  SETTING: {
    ROLE: ROLE,
    USER: USER,
    AUDIT_LOG: USER_MANAGEMENT_AUDIT_LOG,
  },
};

export { APP_PERMISSIONS };
